import React from 'react'
import LogoOnly from '../../images/logo_only.png';
import NameOnly from '../../images/logo_only_name.png';
import NameOnlyDarkMode from '../../images/logo_only_name_dark.png';
import './logoComponent.css';

const LogoComponent = ({isDarkMode}) => {
    return (
        <div className='logoLeft'>
            <img src={LogoOnly} alt='logo' height={'50px'}/>
            {isDarkMode
            &&
            <img className='logoName' src={NameOnlyDarkMode} alt='Appvertise Ads' height={'45px'}/>
            }
            {!isDarkMode
            &&
            <img className='logoName' src={NameOnly} alt='Appvertise Ads' height={'45px'}/>
            }
        </div>
    )
}

export default LogoComponent